export default __webpack_public_path__ + "static/media/star2upward.93b741bd.svg";